/* Квиз «Nájdite rutinu, ktorá Vašej pleti sadne» — витрина moon-skin.sk.
   Исходник: storefront/quiz/ms-quiz.js в репозитории склада; в тему SK
   заливается как assets/ms-quiz.js (см. docs/quiz.md).
   Подбор делает сервер склада (/api/quiz/public), страница только задаёт
   вопросы, показывает три комплекта и кладёт выбранное в корзину.
   Вид — в стиле темы Flow: шрифты и цвета темы, почти прямые углы,
   чёрная заливка выбранного, розовый из логотипа как акцент. */
(function () {
  'use strict';
  var root = document.getElementById('ms-quiz');
  if (!root) return;
  var API = root.getAttribute('data-api') || 'https://wh7.moon-skin.eu/api/quiz/public';
  var STORE_KEY = 'ms_quiz_state_v2';
  var PROOF = {};
  try { PROOF = JSON.parse((document.getElementById('ms-quiz-proof') || {}).textContent || '{}'); } catch (e) {}
  var RATING = parseFloat(String(PROOF.rating || '').replace(',', '.')) || 0;
  var REVIEWS = parseInt(String(PROOF.reviews || '').replace(/\D/g, ''), 10) || 0;

  // ── Вопросы ────────────────────────────────────────────────
  var Q = [
    { key: 'skin', title: 'Ako sa cíti Vaša pleť 2 hodiny po umytí?', type: 'single',
      why: 'Typ pleti určuje textúry: suchá pleť potrebuje bohatšie krémy, mastná ľahké gély, ktoré neupchávajú póry. Zmiešanej dáme niečo medzi.',
      options: [
        { v: 'dry', t: 'Napnutá a suchá', d: 'Niekedy sa olupuje' },
        { v: 'combo', t: 'Lesklá v T-zóne', d: 'Čelo, nos a brada' },
        { v: 'oily', t: 'Lesklá takmer všade', d: 'Na konci dňa celá tvár' },
        { v: 'normal', t: 'Pohodlná', d: 'Bez lesku aj napätia' }
      ] },
    { key: 'goals', title: 'Čo chcete na pleti zlepšiť?', type: 'multi', max: 2, sub: 'Vyberte 1 – 2. Prvá voľba je hlavná.',
      why: 'Ciele určujú účinné látky v sére a tonikách. Hlavný cieľ má prednosť, druhý doplníme tam, kde to dáva zmysel.',
      options: [
        { v: 'acne', t: 'Pupienky a nečistoty' },
        { v: 'pores', t: 'Rozšírené póry a mastnota' },
        { v: 'pigment', t: 'Škvrny a nerovnomerný tón' },
        { v: 'aging', t: 'Vrásky a strata pevnosti' },
        { v: 'dehydration', t: 'Dehydratácia a napätie' },
        { v: 'redness', t: 'Začervenanie a podráždenie' },
        { v: 'dullness', t: 'Unavená pleť bez žiaru' }
      ] },
    { key: 'sensitivity', title: 'Ako reaguje Vaša pleť na nové produkty?', type: 'single', withAvoid: true,
      why: 'Citlivej pleti nedáme parfumáciu, esenciálne oleje, silné kyseliny ani retinol. A do jednej rutiny nikdy nedávame viac silných účinných látok naraz.',
      options: [
        { v: 'never', t: 'Znesie takmer všetko', d: 'Bez väčších problémov' },
        { v: 'sometimes', t: 'Občas zareaguje', d: 'Musím byť opatrná' },
        { v: 'often', t: 'Veľmi citlivo', d: 'Ľahko sa podráždi' }
      ] },
    { key: 'age', title: 'Koľko máte rokov?', type: 'single',
      why: 'Od 25 rokov môžeme zaradiť peptidy a retinol proti vráskam. Mladšej pleti ich zbytočne nenúkame.',
      options: [
        { v: 'u25', t: 'Menej ako 25' },
        { v: '25_34', t: '25 – 34' },
        { v: '35_44', t: '35 – 44' },
        { v: '45p', t: '45 a viac' }
      ] },
    { key: 'time', title: 'Koľko času chcete venovať pleti?', type: 'single',
      why: 'Podľa toho Vám odporučíme veľkosť rutiny. Na výsledku si môžete prepnúť aj ostatné dve.',
      options: [
        { v: 'min', t: 'Pár minút', d: 'Čistenie, krém, SPF' },
        { v: 'std', t: '5 – 10 minút', d: 'Aj tonikum a sérum' },
        { v: 'ritual', t: 'Je to môj rituál', d: 'Rutina naplno, aj s maskou' }
      ] },
    { key: 'budget', title: 'Čo je pre Vás pri kozmetike dôležitejšie?', type: 'single',
      why: 'Pri každom kroku vyberáme z viacerých produktov. Podľa odpovede uprednostníme dostupnejšie alebo účinnejšie.',
      options: [
        { v: 'value', t: 'Rozumná cena' },
        { v: 'balance', t: 'Pomer ceny a výkonu' },
        { v: 'premium', t: 'Hlavne účinok' }
      ] }
  ];
  var AVOID = [
    { v: 'fragrance', t: 'Parfumácia' },
    { v: 'essential_oils', t: 'Esenciálne oleje' },
    { v: 'alcohol', t: 'Alkohol' }
  ];
  var TIERS = [
    { k: 'basic', name: 'Základ' },
    { k: 'full', name: 'Kompletná' },
    { k: 'max', name: 'Prémium' }
  ];
  var AM = ['cleanser', 'toner', 'pad', 'essence', 'serum', 'serum2', 'eye', 'cream', 'spf'];
  var PM = ['oil_cleanser', 'cleanser', 'toner', 'pad', 'essence', 'serum', 'serum2', 'eye', 'cream'];
  var CONSENT_TEXT = 'Kliknutím súhlasíte so zasielaním rutiny, tipov na starostlivosť a ponúk e-mailom.';
  var ICON_CART = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 4h2l2.2 10.2a1 1 0 0 0 1 .8h8.9a1 1 0 0 0 1-.8L20 7H6.2"/><circle cx="9" cy="19" r="1.3"/><circle cx="17" cy="19" r="1.3"/></svg>';

  // ── Состояние ──────────────────────────────────────────────
  function fresh() { return { step: -1, answers: { goals: [], avoid: [] }, result: null, tier: null, pick: {}, off: {}, extra: [], emailSent: false, gift: null }; }
  var S = fresh();
  try {
    var saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
    if (saved && saved.answers) { S = saved; S.off = S.off || {}; }
  } catch (e) {}
  function save() { try { sessionStorage.setItem(STORE_KEY, JSON.stringify(S)); } catch (e) {} }

  // ── Утилиты ────────────────────────────────────────────────
  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    for (var k in attrs || {}) {
      if (k === 'class') el.className = attrs[k];
      else if (k === 'text') el.textContent = attrs[k];
      else if (k === 'html') el.innerHTML = attrs[k];
      else if (k.indexOf('on') === 0) el.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] !== false && attrs[k] != null) el.setAttribute(k, attrs[k]);
    }
    (kids || []).forEach(function (c) { if (c) el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return el;
  }
  function eur(n) { return n.toFixed(2).replace('.', ',') + ' €'; }
  function pad2(n) { return n < 10 ? '0' + n : String(n); }
  function post(path, body) {
    return fetch(API + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.error || 'Chyba ' + r.status); return j; }); });
  }
  function clientId() {
    try { if (window.msAnalytics && window.msAnalytics.clientId) return window.msAnalytics.clientId; } catch (e) {}
    var m = document.cookie.match(/(?:^|;)\s*ms_ci=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : undefined;
  }
  function render(view, keepScroll) {
    root.innerHTML = '';
    root.appendChild(view);
    if (keepScroll) return;
    var top = root.getBoundingClientRect().top + window.pageYOffset - 70;
    if (window.pageYOffset > top) window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }
  // Состояние «Prečo sa pýtame» переживает перерисовку того же вопроса.
  var whyOpen = false;
  function why(text, open) {
    whyOpen = Boolean(open);
    var body = h('p', { class: 'msq-why-body', text: text });
    body.hidden = !whyOpen;
    var btn = h('button', { class: 'msq-why-btn', type: 'button', 'aria-expanded': String(whyOpen) }, ['Prečo sa pýtame ', h('span', { class: 'msq-chev', 'aria-hidden': 'true' })]);
    btn.addEventListener('click', function () { whyOpen = !whyOpen; body.hidden = !whyOpen; btn.setAttribute('aria-expanded', String(whyOpen)); });
    return h('div', { class: 'msq-why' }, [btn, body]);
  }

  // ── Доверие ────────────────────────────────────────────────
  function nbsp(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0'); }
  function stars() {
    var full = Math.round(RATING);
    return h('span', { class: 'msq-stars', 'aria-hidden': 'true', text: '★★★★★'.slice(0, full) + '☆☆☆☆☆'.slice(0, 5 - full) });
  }
  // Без точных цифр (так решил Илья): рейтинг до десятых вниз, число
  // отзывов — вниз до тысяч («5 000+»). Рейтинг — только если Judge.me его отдал.
  function roundDown(n) {
    var step = n >= 1000 ? 1000 : n >= 100 ? 100 : 10;
    return nbsp(Math.floor(n / step) * step) + '+';
  }
  function proof(compact) {
    var rows = [];
    if (RATING >= 4 && REVIEWS >= 100) {
      rows.push(h('p', { class: 'msq-proof-row' }, [stars(), h('b', { text: (Math.floor(RATING * 10) / 10).toFixed(1).replace('.', ',') + ' / 5' }), h('span', { text: '· ' + roundDown(REVIEWS) + ' hodnotení' })]));
    }
    if (compact) {
      if (PROOF.customers) rows.push(h('p', { class: 'msq-proof-row' }, [h('span', { class: 'msq-proof-ico', 'aria-hidden': 'true', text: '✓' }), h('b', { text: PROOF.customers }), h('span', { text: 'zákazníkov' })]));
    } else {
      if (PROOF.customers) rows.push(h('p', { class: 'msq-proof-row' }, [h('span', { class: 'msq-proof-ico', 'aria-hidden': 'true', text: '✓' }), h('span', { text: 'Pridajte sa k' }), h('b', { text: PROOF.customers }), h('span', { text: 'zákazníkom' })]));
      if (PROOF.sold) rows.push(h('p', { class: 'msq-proof-row' }, [h('span', { class: 'msq-proof-ico', 'aria-hidden': 'true', text: '✓' }), h('b', { text: PROOF.sold }), h('span', { text: 'predaných produktov' })]));
    }
    return rows.length ? h('div', { class: 'msq-proof' + (compact ? ' is-compact' : '') }, rows) : null;
  }

  // Шаги рутины на стартовом экране. Рисунки — векторные, условные (без брендов),
  // чтобы не зависеть от наличия конкретных товаров (Илья 17.10.2026: «проблема в привязке»).
  var STEPS = [
    { step: "Odličovanie", when: "večer", art: "<svg viewBox=\"0 0 120 120\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\"><defs><linearGradient id=\"msq-ga\" x1=\"0\" x2=\"1\"><stop offset=\"0\" stop-color=\"#fff6dc\"/><stop offset=\"1\" stop-color=\"#f3d58c\"/></linearGradient></defs><rect width=\"120\" height=\"120\" fill=\"#e3f4f0\"/><ellipse cx=\"60\" cy=\"106\" rx=\"24\" ry=\"4\" fill=\"#1f3a35\" opacity=\".10\"/><rect x=\"40\" y=\"46\" width=\"40\" height=\"60\" rx=\"11\" fill=\"url(#msq-ga)\"/><rect x=\"45\" y=\"52\" width=\"5\" height=\"46\" rx=\"2.5\" fill=\"#fff\" opacity=\".55\"/><rect x=\"47\" y=\"66\" width=\"26\" height=\"24\" rx=\"3\" fill=\"#fff\" opacity=\".9\"/><rect x=\"51\" y=\"72\" width=\"18\" height=\"3\" rx=\"1.5\" fill=\"#f2a0b1\"/><rect x=\"51\" y=\"78\" width=\"12\" height=\"2.5\" rx=\"1.25\" fill=\"#e9c9cf\"/><rect x=\"52\" y=\"38\" width=\"16\" height=\"10\" rx=\"2\" fill=\"#fff\"/><rect x=\"49\" y=\"31\" width=\"22\" height=\"9\" rx=\"3\" fill=\"#f1ece8\"/><rect x=\"57\" y=\"20\" width=\"6\" height=\"12\" fill=\"#e7e1dc\"/><rect x=\"49\" y=\"13\" width=\"24\" height=\"9\" rx=\"3.5\" fill=\"#fff\"/><rect x=\"71\" y=\"15\" width=\"15\" height=\"4.5\" rx=\"2.25\" fill=\"#fff\"/><path d=\"M90 26c2.5 3.5 4 5.8 4 7.6a4 4 0 0 1-8 0c0-1.8 1.5-4.1 4-7.6z\" fill=\"#f3d58c\"/></svg>" },
    { step: "Čistenie", when: "", art: "<svg viewBox=\"0 0 120 120\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\"><defs><linearGradient id=\"msq-gb\" x1=\"0\" x2=\"1\"><stop offset=\"0\" stop-color=\"#dcefff\"/><stop offset=\"1\" stop-color=\"#8fc3ee\"/></linearGradient></defs><rect width=\"120\" height=\"120\" fill=\"#fdeadb\"/><ellipse cx=\"60\" cy=\"108\" rx=\"18\" ry=\"3.5\" fill=\"#5a3a1f\" opacity=\".10\"/><rect x=\"35\" y=\"12\" width=\"50\" height=\"8\" rx=\"2\" fill=\"#a8d1f3\"/><path d=\"M37 19h46l-7 66c-1 3-3 4-6 4H50c-3 0-5-1-6-4z\" fill=\"url(#msq-gb)\"/><path d=\"M42 24h6l-4 56h-3z\" fill=\"#fff\" opacity=\".45\"/><rect x=\"47\" y=\"40\" width=\"26\" height=\"28\" rx=\"3\" fill=\"#fff\" opacity=\".92\"/><rect x=\"51\" y=\"47\" width=\"18\" height=\"3\" rx=\"1.5\" fill=\"#6fb1e6\"/><rect x=\"51\" y=\"53\" width=\"12\" height=\"2.5\" rx=\"1.25\" fill=\"#c5def3\"/><rect x=\"48\" y=\"88\" width=\"24\" height=\"18\" rx=\"4\" fill=\"#fff\"/><rect x=\"48\" y=\"88\" width=\"24\" height=\"4\" rx=\"2\" fill=\"#eef4f9\"/><circle cx=\"92\" cy=\"30\" r=\"7\" fill=\"#fff\" opacity=\".9\"/><circle cx=\"100\" cy=\"44\" r=\"4.5\" fill=\"#fff\" opacity=\".8\"/><circle cx=\"88\" cy=\"48\" r=\"3\" fill=\"#fff\" opacity=\".75\"/><circle cx=\"90\" cy=\"28\" r=\"2\" fill=\"#dcefff\"/></svg>" },
    { step: "Hydratácia", when: "", art: "<svg viewBox=\"0 0 120 120\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\"><defs><linearGradient id=\"msq-gc\" x1=\"0\" x2=\"1\"><stop offset=\"0\" stop-color=\"#ffe9ee\"/><stop offset=\"1\" stop-color=\"#f2abbb\"/></linearGradient><linearGradient id=\"msq-gc2\" x1=\"0\" x2=\"1\"><stop offset=\"0\" stop-color=\"#f6d6c8\"/><stop offset=\"1\" stop-color=\"#d79f8a\"/></linearGradient></defs><rect width=\"120\" height=\"120\" fill=\"#ece4f6\"/><ellipse cx=\"60\" cy=\"108\" rx=\"20\" ry=\"3.5\" fill=\"#3a2a55\" opacity=\".10\"/><path d=\"M44 44c0-6 4-9 9-9h14c5 0 9 3 9 9v56c0 4-3 7-7 7H51c-4 0-7-3-7-7z\" fill=\"url(#msq-gc)\"/><rect x=\"48\" y=\"44\" width=\"5\" height=\"56\" rx=\"2.5\" fill=\"#fff\" opacity=\".55\"/><rect x=\"50\" y=\"14\" width=\"20\" height=\"23\" rx=\"4\" fill=\"url(#msq-gc2)\"/><rect x=\"53\" y=\"16\" width=\"3\" height=\"19\" rx=\"1.5\" fill=\"#fff\" opacity=\".5\"/><rect x=\"50\" y=\"62\" width=\"20\" height=\"26\" rx=\"3\" fill=\"#fff\" opacity=\".9\"/><rect x=\"53\" y=\"68\" width=\"14\" height=\"3\" rx=\"1.5\" fill=\"#e2557a\"/><rect x=\"53\" y=\"74\" width=\"9\" height=\"2.5\" rx=\"1.25\" fill=\"#f4c6d0\"/></svg>" },
    { step: "Sérum", when: "", art: "<svg viewBox=\"0 0 120 120\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\"><defs><linearGradient id=\"msq-gd\" x1=\"0\" x2=\"1\"><stop offset=\"0\" stop-color=\"#ffdfe6\"/><stop offset=\"1\" stop-color=\"#f28aa3\"/></linearGradient><linearGradient id=\"msq-gd2\" x1=\"0\" x2=\"1\"><stop offset=\"0\" stop-color=\"#f6d6c8\"/><stop offset=\"1\" stop-color=\"#d79f8a\"/></linearGradient></defs><rect width=\"120\" height=\"120\" fill=\"#fde3e9\"/><ellipse cx=\"60\" cy=\"108\" rx=\"24\" ry=\"4\" fill=\"#5a1f33\" opacity=\".10\"/><rect x=\"38\" y=\"54\" width=\"44\" height=\"52\" rx=\"14\" fill=\"url(#msq-gd)\"/><rect x=\"43\" y=\"60\" width=\"5\" height=\"40\" rx=\"2.5\" fill=\"#fff\" opacity=\".5\"/><rect x=\"48\" y=\"70\" width=\"24\" height=\"22\" rx=\"3\" fill=\"#fff\" opacity=\".9\"/><rect x=\"52\" y=\"76\" width=\"16\" height=\"3\" rx=\"1.5\" fill=\"#e2557a\"/><rect x=\"52\" y=\"82\" width=\"10\" height=\"2.5\" rx=\"1.25\" fill=\"#f4c6d0\"/><rect x=\"49\" y=\"42\" width=\"22\" height=\"14\" rx=\"3\" fill=\"url(#msq-gd2)\"/><path d=\"M52 42V30c0-9 4-15 8-15s8 6 8 15v12z\" fill=\"#fff\"/><path d=\"M55 40V31c0-6 2-10 5-11\" stroke=\"#f1e6e9\" stroke-width=\"2\" fill=\"none\" stroke-linecap=\"round\"/><path d=\"M92 30c3 4.2 4.8 7 4.8 9.2a4.8 4.8 0 0 1-9.6 0c0-2.2 1.8-5 4.8-9.2z\" fill=\"#f28aa3\"/><path d=\"M90.6 38.6a1.6 1.6 0 0 0 1.6 1.6\" stroke=\"#fff\" stroke-width=\"1.4\" fill=\"none\" stroke-linecap=\"round\"/></svg>" },
    { step: "Krém", when: "", art: "<svg viewBox=\"0 0 120 120\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\"><defs><linearGradient id=\"msq-ge\" x1=\"0\" x2=\"1\"><stop offset=\"0\" stop-color=\"#ffe6eb\"/><stop offset=\"1\" stop-color=\"#f3a9b9\"/></linearGradient><linearGradient id=\"msq-ge2\" x1=\"0\" x2=\"1\"><stop offset=\"0\" stop-color=\"#f8dccf\"/><stop offset=\"1\" stop-color=\"#d79f8a\"/></linearGradient></defs><rect width=\"120\" height=\"120\" fill=\"#fdeadb\"/><ellipse cx=\"60\" cy=\"102\" rx=\"36\" ry=\"4.5\" fill=\"#5a3a1f\" opacity=\".10\"/><rect x=\"26\" y=\"60\" width=\"68\" height=\"40\" rx=\"11\" fill=\"url(#msq-ge)\"/><rect x=\"31\" y=\"64\" width=\"6\" height=\"30\" rx=\"3\" fill=\"#fff\" opacity=\".5\"/><rect x=\"44\" y=\"70\" width=\"32\" height=\"18\" rx=\"3\" fill=\"#fff\" opacity=\".9\"/><rect x=\"49\" y=\"75\" width=\"22\" height=\"3\" rx=\"1.5\" fill=\"#e2557a\"/><rect x=\"49\" y=\"81\" width=\"14\" height=\"2.5\" rx=\"1.25\" fill=\"#f4c6d0\"/><rect x=\"23\" y=\"42\" width=\"74\" height=\"22\" rx=\"7\" fill=\"url(#msq-ge2)\"/><rect x=\"28\" y=\"45\" width=\"40\" height=\"4\" rx=\"2\" fill=\"#fff\" opacity=\".45\"/><path d=\"M48 34c4-6 20-6 24 0\" stroke=\"#fff\" stroke-width=\"3\" fill=\"none\" stroke-linecap=\"round\" opacity=\".9\"/><circle cx=\"60\" cy=\"27\" r=\"3\" fill=\"#fff\" opacity=\".9\"/></svg>" },
    { step: "Ochrana SPF", when: "ráno", art: "<svg viewBox=\"0 0 120 120\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\"><defs><linearGradient id=\"msq-gf\" x1=\"0\" x2=\"1\"><stop offset=\"0\" stop-color=\"#fffaf2\"/><stop offset=\"1\" stop-color=\"#f1e1c8\"/></linearGradient></defs><rect width=\"120\" height=\"120\" fill=\"#e3f4f0\"/><circle cx=\"92\" cy=\"26\" r=\"9\" fill=\"#f7b24a\"/><g stroke=\"#f7b24a\" stroke-width=\"3\" stroke-linecap=\"round\"><path d=\"M92 9v4M92 39v4M75 26h4M105 26h4M80 14l3 3M101 35l3 3M104 14l-3 3M83 35l-3 3\"/></g><ellipse cx=\"56\" cy=\"108\" rx=\"18\" ry=\"3.5\" fill=\"#1f3a35\" opacity=\".10\"/><rect x=\"31\" y=\"14\" width=\"50\" height=\"8\" rx=\"2\" fill=\"#eadbc2\"/><path d=\"M33 21h46l-7 64c-1 3-3 4-6 4H46c-3 0-5-1-6-4z\" fill=\"url(#msq-gf)\"/><path d=\"M38 26h6l-4 54h-3z\" fill=\"#fff\" opacity=\".6\"/><rect x=\"43\" y=\"42\" width=\"26\" height=\"28\" rx=\"3\" fill=\"#fff\"/><circle cx=\"56\" cy=\"52\" r=\"4.5\" fill=\"#f7b24a\"/><rect x=\"48\" y=\"60\" width=\"16\" height=\"3\" rx=\"1.5\" fill=\"#e2557a\"/><rect x=\"44\" y=\"88\" width=\"24\" height=\"18\" rx=\"4\" fill=\"#fff\"/><rect x=\"44\" y=\"88\" width=\"24\" height=\"4\" rx=\"2\" fill=\"#f3ede4\"/></svg>" }
  ];

  // ── Старт ──────────────────────────────────────────────────
  function intro() {
    // шаги рутины: номер, рисунок шага (векторный, не привязан к товарам), название
    var tiles = STEPS.map(function (it, i) {
      var pic = h('span', { class: 'msq-step-pic' }, [
        h('span', { class: 'msq-step-num', text: String(i + 1) }),
        it.when ? h('span', { class: 'msq-step-when', text: it.when }) : null
      ]);
      pic.insertAdjacentHTML('afterbegin', it.art);
      return h('span', { class: 'msq-step' }, [pic, h('span', { class: 'msq-step-name', text: it.step })]);
    });
    render(h('section', { class: 'msq-intro' }, [
      h('div', { class: 'msq-intro-text' }, [
        h('h1', { class: 'msq-display', text: 'Rutina na mieru' }),
        h('p', { class: 'msq-lead', text: 'Stačí 6 otázok. Zostavíme Vám rannú aj večernú rutinu z produktov, ktoré máme skladom, v troch veľkostiach na výber.' })
      ]),
      h('div', { class: 'msq-hero msq-hero--steps' }, tiles),
      h('button', { class: 'msq-btn msq-btn-block msq-btn-3d', type: 'button', onclick: function () { S.step = 0; save(); question(); } }, ['Začať kvíz ', h('span', { class: 'msq-arrow', 'aria-hidden': 'true', text: '→' })]),
      proof(false),
      h('ul', { class: 'msq-facts' }, [
        h('li', {}, [h('b', { text: '3 rutiny' }), h('span', { text: 'od základu po prémium' })]),
        h('li', {}, [h('b', { text: 'Bez kompromisov' }), h('span', { text: 'vynecháme, čo nechcete' })]),
        h('li', {}, [h('b', { text: 'Od 49 €' }), h('span', { text: 'doprava zadarmo' })])
      ])
    ]));
  }

  // ── Вопросы ────────────────────────────────────────────────
  // keep = true — перерисовка того же вопроса после клика: экран не двигаем.
  // Прокрутка к началу квиза нужна только при переходе к другому вопросу.
  function question(keep) {
    var q = Q[S.step];
    var a = S.answers;
    var n = S.step + 1;
    function canGo() { return q.type === 'multi' ? a.goals.length > 0 : Boolean(a[q.key]); }
    function go() {
      if (!canGo()) return;
      if (S.step < Q.length - 1) { S.step++; save(); question(); } else submit();
    }
    function back() { if (S.step > 0) { S.step--; save(); question(); } else { S.step = -1; save(); intro(); } }

    var opts = h('div', { class: 'msq-options' + (q.type === 'multi' ? ' is-multi' : '') });
    q.options.forEach(function (o) {
      var idx = q.type === 'multi' ? a.goals.indexOf(o.v) : (a[q.key] === o.v ? 0 : -1);
      var on = idx >= 0;
      var btn = h('button', { class: 'msq-opt' + (on ? ' is-on' : ''), type: 'button', 'aria-pressed': on ? 'true' : 'false' }, [
        h('span', { class: 'msq-opt-t', text: o.t }),
        o.d ? h('span', { class: 'msq-opt-d', text: o.d }) : null,
        q.type === 'multi' && on ? h('span', { class: 'msq-opt-n', text: idx === 0 ? 'Hlavný' : '2.' }) : null
      ]);
      btn.addEventListener('click', function () {
        if (q.type === 'multi') {
          var i = a.goals.indexOf(o.v);
          if (i >= 0) a.goals.splice(i, 1);
          else if (a.goals.length < q.max) a.goals.push(o.v);
          else { a.goals.shift(); a.goals.push(o.v); }
          save(); question(true);
        } else {
          // Дальше — только по кнопке «Pokračovať»: клиентка видит свой выбор и может его
          // поменять. Автопереход Илья отклонил 01.10.2026.
          a[q.key] = o.v; save(); question(true);
        }
      });
      opts.appendChild(btn);
    });

    var avoid = null;
    if (q.withAvoid) {
      var chips = h('div', { class: 'msq-chips' });
      AVOID.forEach(function (o) {
        var on = a.avoid.indexOf(o.v) >= 0;
        chips.appendChild(h('button', { class: 'msq-chip' + (on ? ' is-on' : ''), type: 'button', 'aria-pressed': on ? 'true' : 'false', onclick: function () {
          var i = a.avoid.indexOf(o.v);
          if (i >= 0) a.avoid.splice(i, 1); else a.avoid.push(o.v);
          save(); question(true);
        } }, [o.t]));
      });
      avoid = h('div', { class: 'msq-avoid' }, [h('p', { class: 'msq-avoid-t', text: 'Čomu sa chcete vyhnúť? (nepovinné)' }), chips]);
    }

    var next = h('button', { class: 'msq-btn', type: 'button', onclick: go }, [n === Q.length ? 'Zobraziť rutinu ' : 'Pokračovať ', h('span', { class: 'msq-arrow', 'aria-hidden': 'true', text: '→' })]);
    next.disabled = !canGo();
    var bar = h('div', { class: 'msq-progress', role: 'progressbar', 'aria-valuemin': '0', 'aria-valuemax': String(Q.length), 'aria-valuenow': String(n) }, [h('span', { style: 'width:' + (n / Q.length) * 100 + '%' })]);

    render(h('section', { class: 'msq-q' }, [
      bar,
      h('p', { class: 'msq-count' }, [h('b', { text: pad2(n) }), ' / ' + pad2(Q.length)]),
      h('h2', { class: 'msq-title', text: q.title }),
      q.sub ? h('p', { class: 'msq-sub', text: q.sub }) : null,
      opts,
      avoid,
      h('div', { class: 'msq-nav' }, [h('button', { class: 'msq-btn msq-btn-ghost', type: 'button', onclick: back }, ['Späť']), next]),
      why(q.why, keep && whyOpen)
    ]), keep);
  }

  // ── Отправка ответов ───────────────────────────────────────
  function submit() {
    // те же рисунки шагов: тонер, сыворотка, крем
    var tiles = STEPS.slice(2, 5).map(function (it) { var x = h('span', { class: 'msq-loading-art' }); x.innerHTML = it.art; return x; });
    render(h('section', { class: 'msq-loading', 'aria-live': 'polite' }, [
      h('div', { class: 'msq-loading-imgs' }, tiles),
      h('h2', { class: 'msq-title', text: 'Skladáme Vašu rutinu' }),
      h('p', { class: 'msq-sub', text: 'Prechádzame produkty skladom a vyberáme tie, ktoré sedia Vašej pleti.' + (PROOF.sold ? ' Už ' + PROOF.sold + ' predaných produktov.' : '') }),
      h('div', { class: 'msq-dots' }, [h('i'), h('i'), h('i')])
    ]));
    var started = Date.now();
    post('/recommend', { answers: S.answers, clientId: clientId() })
      .then(function (r) {
        var wait = Math.max(0, 1600 - (Date.now() - started)); // пауза, чтобы экран не мелькал
        setTimeout(function () {
          S.result = r; S.tier = r.recommended; S.pick = {}; S.off = {}; S.extra = []; S.emailSent = false; S.gift = null; S.step = Q.length;
          save(); gate();
        }, wait);
      })
      .catch(function (e) {
        render(h('section', { class: 'msq-q' }, [
          h('h2', { class: 'msq-title', text: 'Rutinu sa nepodarilo načítať' }),
          h('p', { class: 'msq-sub', text: e.message || 'Skontrolujte pripojenie a skúste to znova.' }),
          h('button', { class: 'msq-btn msq-btn-block', type: 'button', onclick: submit }, ['Skúsiť znova'])
        ]));
      });
  }

  // ── Результат ──────────────────────────────────────────────
  function slots(tier) { return S.result.tiers[tier] || []; }
  function chosen(tier, slot) {
    var i = (S.pick[tier] && S.pick[tier][slot.step]) || 0;
    return slot.options[i] || slot.options[0];
  }
  function isOff(tier, step) { return Boolean(S.off[tier] && S.off[tier][step]); }
  // Что реально уйдёт в корзину: отмеченные шаги + добавки.
  function cartItems(tier) {
    return slots(tier).filter(function (s) { return !isOff(tier, s.step); }).map(function (s) { return chosen(tier, s); }).concat(S.extra);
  }
  function total(tier) { return cartItems(tier).reduce(function (x, i) { return x + i.price; }, 0); }
  function tierTotal(tier) { return slots(tier).reduce(function (x, s) { return x + chosen(tier, s).price; }, 0); }

  function priceEl(it) {
    return h('span', { class: 'msq-price' }, it.compareAt
      ? [h('s', { text: eur(it.compareAt) }), h('b', { class: 'is-sale', text: eur(it.price) })]
      : [h('b', { text: eur(it.price) })]);
  }

  function usage(it) {
    if (it.step === 'mask') return '1 – 2× týždenne večer';
    if (it.am && it.pm) return 'ráno aj večer';
    return it.am ? 'len ráno' : 'len večer';
  }

  function card(slot, it) {
    var tier = S.tier;
    var count = slot ? slot.options.length : 1;
    var cur = slot ? ((S.pick[tier] && S.pick[tier][slot.step]) || 0) : 0;
    var off = slot ? isOff(tier, slot.step) : false;
    var check = h('button', { class: 'msq-check' + (off ? '' : ' is-on'), type: 'button', role: 'checkbox', 'aria-checked': off ? 'false' : 'true', 'aria-label': (off ? 'Pridať do rutiny: ' : 'Vynechať z rutiny: ') + it.title });
    check.addEventListener('click', function () {
      if (!slot) { S.extra = S.extra.filter(function (x) { return x.sku !== it.sku; }); save(); result(true); return; }
      S.off[tier] = S.off[tier] || {};
      S.off[tier][slot.step] = !off;
      save(); result(true);
    });
    return h('article', { class: 'msq-item' + (off ? ' is-off' : '') + (slot ? '' : ' is-extra') }, [
      check,
      h('a', { class: 'msq-img', href: it.url, target: '_blank', rel: 'noopener' }, [it.image ? h('img', { src: it.image, alt: it.title, loading: 'lazy', width: '96', height: '96' }) : null]),
      h('div', { class: 'msq-item-body' }, [
        h('p', { class: 'msq-item-step', text: slot ? it.stepLabel : 'Navyše · ' + it.stepLabel }),
        h('a', { class: 'msq-item-title', href: it.url, target: '_blank', rel: 'noopener', text: it.title }),
        it.benefit ? h('p', { class: 'msq-item-benefit', text: it.benefit }) : null,
        more(it),
        h('p', { class: 'msq-item-use', text: '✓ ' + usage(it) }),
        h('div', { class: 'msq-item-foot' }, [
          priceEl(it),
          slot && count > 1 && !off ? h('button', { class: 'msq-swap', type: 'button', onclick: function () {
            S.pick[tier] = S.pick[tier] || {};
            S.pick[tier][slot.step] = (cur + 1) % count;
            save(); result(true);
          } }, ['Vymeniť ', h('span', { text: (cur + 1) + '/' + count })]) : null
        ])
      ])
    ]);
  }

  // «Čítať viac» — описание с витрины, раскрывается на месте.
  function more(it) {
    if (!it.desc || it.desc === it.benefit) return null;
    var body = h('p', { class: 'msq-item-desc', text: it.desc });
    body.hidden = true;
    var btn = h('button', { class: 'msq-more', type: 'button', 'aria-expanded': 'false' }, ['Čítať viac']);
    btn.addEventListener('click', function () {
      body.hidden = !body.hidden;
      btn.setAttribute('aria-expanded', String(!body.hidden));
      btn.textContent = body.hidden ? 'Čítať viac' : 'Skryť';
    });
    return h('div', { class: 'msq-item-more' }, [btn, body]);
  }

  // Метки кожи плашками — в шапке профиля (на стене email и на результате).
  function chips(tags) {
    return h('div', { class: 'msq-chips' }, tags.map(function (x) { return h('span', { class: 'msq-chip-tag', text: x }); }));
  }

  function group(title, icon, note, list) {
    if (!list.length) return null;
    return h('section', { class: 'msq-group' }, [
      h('h3', { class: 'msq-group-t' }, [h('span', { class: 'msq-group-i', 'aria-hidden': 'true', text: icon }), title]),
      note ? h('p', { class: 'msq-group-note', text: note }) : null,
      h('div', { class: 'msq-list' }, list)
    ]);
  }

  function result(keepScroll) {
    var r = S.result;
    var tier = S.tier;
    root.classList.add('is-result');
    var page = h('div', { class: 'msq-result' });
    var wrap = h('div', { class: 'msq-main' });

    // Профиль
    page.appendChild(h('section', { class: 'msq-profile' }, [
      h('p', { class: 'msq-eyebrow', text: 'Váš profil pleti' }),
      h('h1', { class: 'msq-display', text: r.profile.name }),
      chips(r.profile.tags),
      h('p', { class: 'msq-lead', text: r.profile.text }),
      S.emailSent ? h('p', { class: 'msq-sent', text: '✓ Rutinu sme poslali aj na Váš e-mail.' }) : null
    ]));

    // Переключатель комплектов
    function tiersEl() {
    var tabs = h('div', { class: 'msq-tiers', role: 'tablist', 'aria-label': 'Veľkosť rutiny' });
    TIERS.forEach(function (t) {
      var n = slots(t.k).length;
      if (!n) return;
      var on = tier === t.k;
      tabs.appendChild(h('button', { class: 'msq-tier' + (on ? ' is-on' : ''), type: 'button', role: 'tab', 'aria-selected': on ? 'true' : 'false', onclick: function () { S.tier = t.k; S.extra = []; save(); result(true); } }, [
        t.k === 'full' ? h('span', { class: 'msq-rec', text: 'Odporúčame' }) : null, // плашка всегда на средней (решение Ильи)
        h('b', { text: t.name }),
        h('span', { class: 'msq-tier-n', text: n + ' ' + (n < 5 ? 'produkty' : 'produktov') }),
        h('span', { class: 'msq-tier-p', text: eur(tierTotal(t.k)) })
      ]));
    });
    return tabs;
    }
    wrap.appendChild(h('div', { class: 'msq-tiers-wrap' }, [h('p', { class: 'msq-eyebrow msq-center', text: 'Vyberte veľkosť rutiny' }), tiersEl(), proof(true)]));

    // Средства: утро (всё, что утром), вечер (только вечерние), раз в неделю.
    var am = [], pmOnly = [], weekly = [];
    slots(tier).forEach(function (s) {
      var it = chosen(tier, s);
      if (s.step === 'mask') weekly.push(card(s, it));
      else if (it.am) am.push({ s: s, it: it });
      else pmOnly.push({ s: s, it: it });
    });
    am.sort(function (x, y) { return AM.indexOf(x.s.step) - AM.indexOf(y.s.step); });
    var pmFlow = [];
    PM.forEach(function (st) { slots(tier).forEach(function (s) { var it = chosen(tier, s); if (s.step === st && it.pm && !isOff(tier, st)) pmFlow.push(it.stepLabel); }); });
    // Пустую группу (например, без маски) не рисуем вовсе.
    [
      group('Ranná rutina', '☀', null, am.map(function (x) { return card(x.s, x.it); })),
      group('Večerná rutina', '☾', pmFlow.length ? 'Postup večer: ' + pmFlow.join(' → ') : null, pmOnly.map(function (x) { return card(x.s, x.it); })),
      group('Týždenne navyše', '✦', null, weekly),
      group('Pridané navyše', '+', null, S.extra.map(function (it) { return card(null, it); }))
    ].forEach(function (g) { if (g) wrap.appendChild(g); });

    wrap.appendChild(h('div', { class: 'msq-after' }, actions()));
    wrap.appendChild(cartBar());
    // На компьютере справа — панель: размер рутины, цель, сумма, корзина.
    // На телефоне её нет: там переключатель сверху и полоса корзины внизу.
    page.appendChild(h('div', { class: 'msq-layout' }, [wrap, panel(tiersEl())]));
    render(page, keepScroll);
  }

  function panel(tabs) {
    var sum = total(S.tier);
    var g = goal(sum);
    var btn = h('button', { class: 'msq-btn msq-btn-block msq-btn-cart', type: 'button', html: ICON_CART + '<span>Do košíka</span>' });
    btn.disabled = cartItems(S.tier).length === 0;
    btn.addEventListener('click', function () { addToCart(btn); });
    return h('aside', { class: 'msq-panel' }, [
      h('p', { class: 'msq-eyebrow', text: 'Veľkosť rutiny' }),
      tabs,
      h('div', { class: 'msq-ship' }, [
        h('p', { class: 'msq-ship-t' + (g.gap ? '' : ' is-ok') }, g.gap ? [g.text, h('b', { text: eur(g.gap) })] : [g.text]),
        h('div', { class: 'msq-ship-bar' }, [h('span', { style: 'width:' + Math.min(100, (sum / g.at) * 100) + '%' })])
      ]),
      h('div', { class: 'msq-panel-total' }, [h('span', { text: 'Spolu' }), h('b', { class: 'msq-total', text: eur(sum) })]),
      btn,
      h('button', { class: 'msq-btn msq-btn-pink msq-btn-block', type: 'button', onclick: howTo }, ['Ako používať rutinu']),
      proof(true)
    ]);
  }

  function restart() { S = fresh(); save(); root.classList.remove('is-result'); intro(); }

  // Кнопки под списком.
  function actions() {
    return [
      h('button', { class: 'msq-btn msq-btn-pink msq-btn-block', type: 'button', onclick: howTo }, ['Ako používať rutinu']),
      h('button', { class: 'msq-btn msq-btn-ghost msq-btn-block', type: 'button', onclick: restart }, ['Spustiť kvíz znova'])
    ];
  }

  // Ближайшая цель корзины: сначала доставка (49 €), потом подарок квиза (55 €).
  function goal(sum) {
    var free = S.result.freeShippingEur || 49;
    var giftAt = S.gift && S.gift.threshold ? S.gift.threshold : 0;
    if (sum < free) return { gap: Math.round((free - sum) * 100) / 100, at: free, text: 'Do dopravy zadarmo chýba ' };
    if (giftAt && sum < giftAt) return { gap: Math.round((giftAt - sum) * 100) / 100, at: giftAt, text: 'Do darčeka chýba ' };
    return { gap: 0, at: Math.max(free, giftAt), text: giftAt ? '✓ Doprava zadarmo a darček - čistiaca pena' : '✓ Doprava zadarmo' };
  }

  // ── Стена email ────────────────────────────────────────────
  // Рутина видна после email (решение Ильи 15.10.2026, как у Dalora): за email —
  // подарок к рутине и копия рутины в почту. Сразу после отправки рутина
  // открывается на экране: посмотреть, заменить, купить.
  // Для тестов Ильи: ссылка с ?test=1 пропускает стену email на всю вкладку.
  var TEST = false;
  try {
    if (/[?&]test=1\b/.test(location.search)) sessionStorage.setItem('msq_test', '1');
    TEST = sessionStorage.getItem('msq_test') === '1';
  } catch (e) {}

  function gate() {
    var r = S.result;
    if (TEST) { result(); return; }
    root.classList.remove('is-result');
    var input = h('input', { class: 'msq-input', type: 'email', id: 'msq-email', name: 'email', placeholder: 'Váš e-mail', autocomplete: 'email', required: 'required', 'aria-label': 'E-mail' });
    // Галочки нет: согласие — само нажатие кнопки «Súhlasím…», текст согласия
    // стоит прямо над ней (решение Ильи 15.10.2026). Заранее отмеченная галочка
    // согласием по GDPR не считается (Суд ЕС, Planet49), активный клик — да.
    var err = h('p', { class: 'msq-err', role: 'alert' });
    var btn = h('button', { class: 'msq-btn msq-btn-block', type: 'submit' }, ['Súhlasím a zobraziť rutinu ', h('span', { class: 'msq-arrow', 'aria-hidden': 'true', text: '→' })]);
    var form = h('form', { class: 'msq-gate-form', novalidate: 'novalidate' }, [
      input,
      h('p', { class: 'msq-consent-note', text: CONSENT_TEXT + ' Odhlásiť sa dá kedykoľvek.' }),
      err,
      btn,
      h('p', { class: 'msq-fine' }, [h('a', { href: '/policies/privacy-policy', target: '_blank', rel: 'noopener', text: 'Zásady ochrany osobných údajov' })])
    ]);
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var email = String(input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = 'Skontrolujte, prosím, e-mailovú adresu.'; input.focus(); return; }
      err.textContent = '';
      btn.disabled = true; btn.textContent = 'Pripravujeme…';
      var list = slots(S.tier).map(function (s) { return { sku: chosen(S.tier, s).sku, step: s.step }; });
      post('/email', { sessionId: r.sessionId, email: email, consent: true, tier: S.tier, items: list })
        .then(function (res) {
          S.emailSent = true;
          if (res && res.gift) { S.gift = res.gift; keepGift(res.gift); }
          save(); result();
        })
        .catch(function (e) { btn.disabled = false; btn.textContent = 'Súhlasím a zobraziť rutinu'; err.textContent = e.message || 'Nepodarilo sa odoslať. Skúste to znova.'; });
    });
    render(h('section', { class: 'msq-gate' }, [
      h('p', { class: 'msq-eyebrow', text: 'Váš profil pleti' }),
      h('h1', { class: 'msq-display', text: r.profile.name }),
      chips(r.profile.tags),
      h('p', { class: 'msq-lead', text: r.profile.text }),
      h('div', { class: 'msq-gate-card' }, [
        h('p', { class: 'msq-email-t', text: 'Kam Vám máme poslať rutinu?' }),
        h('p', { class: 'msq-sub', text: 'Ukážeme Vám ju hneď tu a pošleme aj s návodom do schránky, aby ste ju mali vždy po ruke.' }),
        h('p', { class: 'msq-gift' }, ['🎁 ', h('b', { text: 'Darček k rutine: ' }), 'čistiaca pena FarmStay Citrus Yuja, 100 ml']),
        form
      ]),
      proof(true)
    ]));
  }

  // Подарок кладёт в корзину скрипт темы (theme.liquid): ему нужны код, товар,
  // срок и порог. Порог у квиза свой (55 €), у подписки на сайте 39 €.
  function keepGift(g) {
    try {
      localStorage.setItem('ms_gift_code', g.code);
      localStorage.setItem('ms_gift_variant', String(g.variantId));
      localStorage.setItem('ms_gift_until', String(g.until ? Date.parse(g.until) : Date.now() + 30 * 864e5));
      localStorage.setItem('ms_gift_threshold', String(Math.round((g.threshold || 39) * 100)));
      sessionStorage.removeItem('ms_gift_tried'); sessionStorage.removeItem('ms_gift_giveup');
    } catch (e) {}
  }


  // ── Ako používať rutinu ────────────────────────────────────
  // Пошаговая инструкция по выбранным средствам: утро, вечер, раз в неделю.
  var HOW = {
    oil_cleanser: 'Na suchú pleť suchými rukami. 1 – 2 dávky vmasírujte 30 – 60 sekúnd, pridajte trochu vody, kým olej alebo balzam nezbelie, a opláchnite. Rozpustí SPF aj make-up.',
    cleanser: 'Malé množstvo napeňte vo vlhkých dlaniach, jemne masírujte 30 – 60 sekúnd a opláchnite vlažnou vodou.',
    toner: 'Nalejte do dlaní a jemne vtlačte do ešte mierne vlhkej pleti. Suchej pleti pokojne doprajte 2 – 3 vrstvy.',
    pad: 'Tampónom prejdite tvár od stredu von, okolie očí vynechajte.',
    essence: 'Pár kvapiek vtlačte dlaňami do pleti hneď po toniku.',
    serum: '2 – 3 kvapky rozotrite po tvári a jemne vtlačte. Pri dvoch sérach najprv to redšie.',
    serum2: '2 – 3 kvapky po prvom sére, keď sa vstrebe.',
    eye: 'Množstvo ako zrnko ryže jemne vťapkajte prstenníkom okolo očí, netrite.',
    cream: 'Hrášok krému rozotrite po tvári a krku. Uzamkne hydratáciu z predchádzajúcich krokov.',
    spf: 'Posledný krok ráno. Dve dĺžky prsta na tvár a krk 15 minút pred odchodom von. Ak ste dlho vonku, obnovte každé 2 hodiny.',
    mask: '1 – 2× týždenne večer po toniku, podľa návodu na obale. Potom pokračujte sérom a krémom.',
    sheet_mask: 'Na 15 – 20 minút po toniku, zvyšok esencie vtlačte do pleti.',
    patch: 'Na čistú a suchú pleť, podľa návodu na obale.'
  };
  function howTo() {
    var tier = S.tier;
    var list = slots(tier).filter(function (s) { return !isOff(tier, s.step); }).map(function (s) { var it = chosen(tier, s); return { step: s.step, it: it }; })
      .concat(S.extra.map(function (it) { return { step: it.step, it: it }; }));
    function steps(order, filter) {
      var out = [];
      order.forEach(function (st) { list.forEach(function (x) { if (x.step === st && filter(x)) out.push(x); }); });
      return out;
    }
    var am = steps(AM, function (x) { return x.it.am && x.step !== 'mask'; });
    var pm = steps(PM, function (x) { return x.it.pm && x.step !== 'mask' && x.step !== 'spf'; });
    var weekly = list.filter(function (x) { return ['mask', 'sheet_mask', 'patch'].indexOf(x.step) >= 0; });
    function note(x) {
      var f = x.it.flags || [];
      if (f.indexOf('retinol') >= 0) return 'Obsahuje retinol: len večer, prvé 2 týždne 2 – 3× týždenne. Ráno vždy SPF.';
      if (f.indexOf('acids') >= 0) return 'Obsahuje kyseliny: začnite 2 – 3× týždenne a ráno nezabudnite na SPF.';
      if (f.indexOf('vitamin_c') >= 0) return 'Vitamín C funguje najlepšie ráno pod SPF.';
      return '';
    }
    function block(title, icon, arr) {
      if (!arr.length) return null;
      return h('section', { class: 'msq-how-g' }, [
        h('h3', { class: 'msq-group-t' }, [h('span', { class: 'msq-group-i', 'aria-hidden': 'true', text: icon }), title]),
        h('ol', { class: 'msq-how-list' }, arr.map(function (x) {
          var n = note(x);
          return h('li', {}, [
            h('p', { class: 'msq-item-step', text: x.it.stepLabel }),
            h('p', { class: 'msq-how-name', text: x.it.title }),
            h('p', { class: 'msq-how-text', text: HOW[x.step] || '' }),
            n ? h('p', { class: 'msq-how-note', text: n }) : null
          ]);
        }))
      ]);
    }
    var hasAcid = list.some(function (x) { return (x.it.flags || []).indexOf('acids') >= 0; });
    var hasRet = list.some(function (x) { return (x.it.flags || []).indexOf('retinol') >= 0; });
    var tips = [
      'Nové produkty pridávajte postupne – jeden každé 3 – 4 dni. Hneď uvidíte, čo pleti sedí.',
      'Pred prvým použitím vyskúšajte produkt na malej ploche, napríklad za uchom.',
      'Výsledky sa ukážu po 4 – 6 týždňoch pravidelného používania.'
    ];
    if (hasAcid && hasRet) tips.push('Kyseliny a retinol nepoužívajte v ten istý večer – striedajte ich.');
    var close = h('button', { class: 'msq-sheet-x', type: 'button', 'aria-label': 'Zavrieť' }, ['×']);
    var sheet = h('div', { class: 'msq-sheet', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Ako používať rutinu' }, [
      h('div', { class: 'msq-sheet-head' }, [h('p', { class: 'msq-email-t', text: 'Ako používať rutinu' }), close]),
      h('div', { class: 'msq-sheet-body' }, [
        block('Ráno', '☀', am),
        block('Večer', '☾', pm),
        block('Raz za týždeň', '✦', weekly),
        h('section', { class: 'msq-how-g' }, [
          h('h3', { class: 'msq-group-t' }, [h('span', { class: 'msq-group-i', 'aria-hidden': 'true', text: '♡' }), 'Dôležité']),
          h('ul', { class: 'msq-how-tips' }, tips.map(function (t) { return h('li', { text: t }); }))
        ])
      ])
    ]);
    var overlay = h('div', { class: 'msq-overlay' }, [sheet]);
    function shut() { overlay.remove(); document.documentElement.style.overflow = ''; document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') shut(); }
    close.addEventListener('click', shut);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) shut(); });
    document.addEventListener('keydown', onKey);
    root.appendChild(overlay);
    document.documentElement.style.overflow = 'hidden';
    close.focus();
  }

  function cartBar() {
    var sum = total(S.tier);
    var g = goal(sum);
    var gap = g.gap;
    var ship;
    if (gap > 0) {
      var have = cartItems(S.tier).map(function (i) { return i.sku; });
      var ups = (S.result.upsell || []).filter(function (u) { return have.indexOf(u.sku) < 0; });
      // Самая дешёвая добавка, что закрывает разницу; иначе самая дорогая из списка.
      var fit = ups.filter(function (u) { return u.price >= gap; })[0] || ups[ups.length - 1];
      ship = h('div', { class: 'msq-ship' }, [
        h('p', { class: 'msq-ship-t' }, [g.text, h('b', { text: eur(gap) })]),
        h('div', { class: 'msq-ship-bar' }, [h('span', { style: 'width:' + Math.min(100, (sum / g.at) * 100) + '%' })]),
        fit ? h('button', { class: 'msq-upsell', type: 'button', onclick: function () { S.extra.push(fit); save(); result(true); } }, [
          fit.image ? h('img', { src: fit.image, alt: '', width: '36', height: '36' }) : null,
          h('span', { class: 'msq-upsell-t', text: fit.title }),
          h('span', { class: 'msq-upsell-p', text: '+ ' + eur(fit.price) })
        ]) : null
      ]);
    } else {
      ship = h('div', { class: 'msq-ship' }, [
        h('p', { class: 'msq-ship-t is-ok', text: g.text }),
        h('div', { class: 'msq-ship-bar' }, [h('span', { style: 'width:100%' })])
      ]);
    }
    var btn = h('button', { class: 'msq-btn msq-btn-cart', type: 'button', html: ICON_CART + '<span>Do košíka</span>' });
    btn.disabled = cartItems(S.tier).length === 0;
    btn.addEventListener('click', function () { addToCart(btn); });
    var barEl = h('div', { class: 'msq-bar' }, [
      ship,
      h('div', { class: 'msq-bar-row' }, [h('b', { class: 'msq-total', text: eur(sum) }), btn])
    ]);
    watchBottom(barEl);
    return barEl;
  }

  // Чужие полосы, прибитые к низу экрана (баннер cookie, плашки приложений),
  // не должны закрывать кнопку корзины: поднимаем панель над ними.
  var bottomTimer = null;
  function watchBottom(bar) {
    function check() {
      if (!document.body.contains(bar)) { clearInterval(bottomTimer); bottomTimer = null; return; }
      var lift = 0;
      var x = window.innerWidth / 2, y = window.innerHeight - 2;
      var els = document.elementsFromPoint ? document.elementsFromPoint(x, y) : [];
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (root.contains(el)) continue;
        for (var p = el; p && p !== document.body; p = p.parentElement) {
          var cs = getComputedStyle(p);
          if (cs.position === 'fixed' && cs.display !== 'none' && cs.visibility !== 'hidden') {
            var r = p.getBoundingClientRect();
            if (r.height < window.innerHeight * 0.6) lift = Math.max(lift, Math.round(window.innerHeight - r.top));
            break;
          }
        }
      }
      bar.style.bottom = lift + 'px';
    }
    if (bottomTimer) clearInterval(bottomTimer);
    bottomTimer = setInterval(check, 700);
    setTimeout(check, 50);
  }

  function addToCart(btn) {
    var list = cartItems(S.tier);
    if (!list.length) return;
    btn.disabled = true;
    btn.innerHTML = '<span>Pridávame…</span>';
    function one(i) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(i.variantId), quantity: 1 }] }) }).catch(function () {});
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: list.map(function (i) { return { id: Number(i.variantId), quantity: 1 }; }) }) })
      .then(function (r) {
        // Если какой-то товар закончился, Shopify отклонит всю пачку — кладём по одному.
        if (r.ok) return;
        return list.reduce(function (p, i) { return p.then(function () { return one(i); }); }, Promise.resolve());
      })
      .then(function () {
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { ms_quiz: S.result.sessionId } }) }).catch(function () {});
      })
      .then(function () {
        try { post('/cart', { sessionId: S.result.sessionId, tier: S.tier, total: Math.round(total(S.tier) * 100) / 100 }).catch(function () {}); } catch (e) {}
        window.location.href = '/cart';
      });
  }

  // ── Старт ──────────────────────────────────────────────────
  if (S.result && S.step >= Q.length) { if (S.emailSent) result(true); else gate(); }
  else if (S.step >= 0 && S.step < Q.length) question();
  else intro();
})();
